// extracted by mini-css-extract-plugin
export default {"main_div":"Navbar_main_div__DuWO-","logo":"Navbar_logo__AU03Y","pages":"Navbar_pages__9lMtg","page":"Navbar_page__o4pFI","Login_button":"Navbar_Login_button__nKe70"};